import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';

const { colors, spacing } = dggTheme;

export const icon = css`
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
  color: ${colors.neutralWhite};
`;

export const container = css`
  display: flex;
  justify-content: space-between;
  max-width: ${pxToRem(280)};
  margin: 0 auto;
`;
export const link = css`
  display: inline-block;
  margin: 0 ${pxToRem(spacing.xs)} 0;
`;
